import { UTSLocale } from "@smile2impress/attraction-constants";

import { TrustpilotStyle, TrustpilotWidgetVariant } from "./Trustpilot.types";

const widgetProps: Record<TrustpilotWidgetVariant, TrustpilotStyle> = {
    [TrustpilotWidgetVariant.MICRO_TRUST_SCORE]: {
        "data-template-id": "5419b6a8b0d04a076446a9ad",
        "data-style-height": "20px",
        "data-style-width": "285px",
        style: {
            maxWidth: "fit-content",
        },
    },
    [TrustpilotWidgetVariant.MINI]: {
        "data-template-id": "5419b6a8b0d04a076446a9ad",
        "data-style-width": "120px",
        "data-style-height": "60px",
    },
    [TrustpilotWidgetVariant.CAROUSEL]: {
        "data-template-id": "5419b6a8b0d04a076446a9ad",
        "data-style-width": "100%",
        "data-style-height": "150px",
    },
    [TrustpilotWidgetVariant.QUOTE]: {
        "data-template-id": "5419b6a8b0d04a076446a9ad",
        "data-style-width": "100%",
        "data-style-height": "300px",
    },
};

export const getWidgetProps = (
    variant: TrustpilotWidgetVariant,
    locale: UTSLocale
) => {
    const props = widgetProps[variant];

    return typeof props === "function" ? props(locale) : props;
};
